import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmacoEditModalComponent.vue?vue&type=template&id=92ef8a02"
import script from "./RsaPazientePrescrizioneFarmacoEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmacoEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports